module.exports = __webpack_public_path__ + "static/media/ic_videoMenu.e17a0ea9.svg";